import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useCartIntermediateContext } from '../../hooks/useCartIntermediateContext'

type CartIntermediateShowDiscountedProductsButtonProps = {
  className?: string
}

export const CartIntermediateShowDiscountedProductsButton: FC<
  CartIntermediateShowDiscountedProductsButtonProps
> = ({ className }) => {
  const {
    specialOffersCollapsibleControls: { handleOpen },
  } = useCartIntermediateContext()

  return (
    <Button
      className={className}
      color="secondary"
      data-qa-id="continue-shopping-button"
      onClick={() => {
        handleOpen()
      }}
    >
      <FormattedMessage id="cartIntermediate.drawer.specialOffers.button" />
    </Button>
  )
}
